import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const createPotentialSensors = async (data) => {
  return await axios.post('potential-sensors', data)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default createPotentialSensors;